import { Box, Stack, Typography } from "@mui/material";

/** Which way the crane's camera looks across this layout. */
export const CameraDirectionItem = ({ label }: { label: string }) => (
  <Stack direction="row" alignItems="center" spacing={1}>
    <Typography
      variant="caption"
      sx={{ color: "text.secondary", fontWeight: "fontWeightBold" }}
    >
      {label}
    </Typography>
    <Stack direction="row" alignItems="center">
      <Box sx={{ width: 44, height: "1.5px", bgcolor: "text.secondary" }} />
      <Box
        sx={{
          width: 0,
          height: 0,
          borderTop: "4px solid transparent",
          borderBottom: "4px solid transparent",
          borderLeft: "7px solid",
          borderLeftColor: "text.secondary",
        }}
      />
    </Stack>
  </Stack>
);
